module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"edit":"@:labels.edit","language":"Default Language","timezone":"Default Timezone"},"fr":{"edit":"@:labels.edit","language":"Langue par défaut","timezone":"Fuseau horaire par défaut"}}')
  delete Component.options._Ctor
}
